import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import css from './SectionListingsSkeleton.module.css';

const SectionListingsSkeleton = props => {
  const { rootClassName, className } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.listingsContent}>
        <div className={css.titleSkeleton}></div>
        <div className={css.carouselSkeleton}>
          {Array.from({ length: 5 }, (_, index) => (
            <div key={index} className={css.listingCardSkeleton}>
              <div className={css.imageSkeleton}></div>
              <div className={css.contentSkeleton}>
                <div className={css.titleSkeletonSmall}></div>
                <div className={css.priceSkeleton}></div>
                <div className={css.locationSkeleton}></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

SectionListingsSkeleton.defaultProps = {
  rootClassName: null,
  className: null,
};

SectionListingsSkeleton.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionListingsSkeleton;
